import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3582f0ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-mif__elm-search" }
const _hoisted_2 = ["placeholder", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconSearch = _resolveComponent("IconSearch")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ui-mif",
    onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
    tabindex: "0"
  }, [
    _createElementVNode("div", {
      class: "ui-mif__elm",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          ref: "searchInput",
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
          type: "text",
          class: "ui-mif__elm-search-input",
          placeholder: _ctx.label,
          value: _ctx.selectedId
        }, null, 40, _hoisted_2),
        (_ctx.isShowIcon)
          ? (_openBlock(), _createBlock(_component_IconSearch, {
              key: 0,
              class: "ui-mif__elm-search-icon",
              color: "rgb(119, 121, 124)",
              width: "16",
              height: "16"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}